export default class VanillaCounter {
  constructor(minusSelector, plusSelector, inputSelector) {
    this.minusBtn = document.querySelector(minusSelector);
    this.plusBtn = document.querySelector(plusSelector);
    this.input = document.querySelector(inputSelector);

    if (!this.minusBtn || !this.plusBtn || !this.input) return;

    this.bindEvents();
    this.normalizeValue();
  }

  getCurrentValue() {
    const value = parseInt(this.input.value, 10);
    return Number.isNaN(value) || value < 1 ? 1 : value;
  }

  setValue(value) {
    this.input.value = value;
    this.input.dispatchEvent(new Event("input", { bubbles: true }));
    this.input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  normalizeValue() {
    this.setValue(this.getCurrentValue());
  }

  decrement() {
    this.setValue(Math.max(1, this.getCurrentValue() - 1));
  }

  increment() {
    this.setValue(this.getCurrentValue() + 1);
  }

  bindEvents() {
    this.minusBtn.addEventListener("click", () => {
      this.decrement();
    });

    this.plusBtn.addEventListener("click", () => {
      this.increment();
    });

    this.input.addEventListener("blur", () => {
      this.normalizeValue();
    });
  }
}
